import { Col, Container, Row } from "react-bootstrap";
import EcomCategoryNavs from "./EcomCategoryNavs";
import EcomLargeBanner from "./EcomLargeBanner";
import EcomRegisterProvider from "./EcomRegisterProvider";
import EcomTopProviders from "./EcomTopProviders";
import EcomNewProviders from "./EcomNewProviders";
import ecom1 from "../../../assets/img/ecommerce/banners/Dealbanner.png";
import { Provider, ProviderCard } from "../../../data/ecommerce/providers";
import { useEffect, useState } from "react";
import { getProviders } from "../../../api";
import {
  getProviderCategories,
  getImageByPosition,
  getLocations,
  getSubCategories,
  isVerifiedUser,
  getRating,
} from "../../../helpers/utils";
import { useTagsStore } from "../../../store/tagsStore";

// Helper to process a provider object
const processProvider = async (provider: Provider): Promise<ProviderCard> => {
  return {
    id: provider.id,
    name: provider.name,
    uniqueName: provider.uniqueName,
    verified: isVerifiedUser(provider.tagIds),
    Location: getLocations(provider.tagIds),
    Category: getProviderCategories(provider.tagIds),
    SubCategory: getSubCategories(provider.tagIds),
    image: await getImageByPosition(provider.logo, true),
    rating: getRating(provider.rating),
    rated: provider.ratingCount,
  };
};

const Homepage = () => {
  const [topProviders, setTopProviders] = useState<ProviderCard[]>([]);
  const [newProviders, setNewProviders] = useState<ProviderCard[]>([]);

  const fetchTopProviders = async () => {
    try {
      const { providerTopUser } = useTagsStore.getState();
      const providers = await getProviders({
        params: {
          tagIds: providerTopUser?.id,
          pageSize: 8,
        },
      });
      const data = await Promise.all(
        providers.data.map(provider => processProvider(provider))
      );
      setTopProviders(data);
    } catch (error) {
      console.error("Error getting providers:", error);
    }
  };

  const fetchNewProviders = async () => {
    try {
      const providers = await getProviders({
        params: {
          orderBy: "createdAt",
          orderType: "desc",
          pageSize: 20,
        },
      });
      const data = await Promise.all(
        providers.data.map(provider => processProvider(provider))
      );
      setNewProviders(data);
    } catch (error) {
      console.error("Error getting providers:", error);
    }
  };

  const fetchData = async () => {
    fetchTopProviders();
  };

  useEffect(() => {
    fetchData();
    fetchNewProviders();
  }, []);

  return (
    <div className="ecommerce-homepage bg-soft pt-5 mb-9">
      <section className="py-0">
        <div className="container-small">
          {/* <div className="scrollbar"> */}
          <div className="">
            <EcomCategoryNavs />
          </div>
        </div>
      </section>
      <section className="py-0 px-xl-3">
        <Container className="px-xl-0 px-xxl-3">
          <Row className="g-3 mb-9">
            <Col xs={12}>
              <EcomLargeBanner />
            </Col>
          </Row>
          {topProviders.length > 0 && (
            <Row className="g-4 mb-6">
              <Col xs={12} lg={9} xxl={10}>
                <EcomTopProviders providers={topProviders} />
              </Col>
              <Col lg={3} xxl={2} className="d-none d-lg-block">
                <div className="h-100 position-relative rounded-3 overflow-hidden">
                  <div
                    className="bg-holder product-bg"
                    style={{
                      backgroundImage: `url(${ecom1})`,
                    }}
                  />
                </div>
              </Col>
            </Row>
          )}
          {newProviders.length > 0 && (
            <div className="mb-6">
              <EcomNewProviders products={newProviders} />
            </div>
          )}
          <EcomRegisterProvider />
        </Container>
      </section>
    </div>
  );
};

export default Homepage;